package com.yet.tetris.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import com.yet.tetris.domain.model.game.TetrominoType
import kotlin.Any
import kotlin.Long

public class BoardCellsQueries(
  driver: SqlDriver,
  private val BoardCellsAdapter: BoardCells.Adapter,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> getAllCells(mapper: (
    positionX: Long,
    positionY: Long,
    pieceType: TetrominoType,
  ) -> T): Query<T> = Query(-514_992_592, arrayOf("BoardCells"), driver, "BoardCells.sq", "getAllCells", "SELECT BoardCells.positionX, BoardCells.positionY, BoardCells.pieceType FROM BoardCells") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      BoardCellsAdapter.pieceTypeAdapter.decode(cursor.getString(2)!!)
    )
  }

  public fun getAllCells(): Query<BoardCells> = getAllCells(::BoardCells)

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertCell(
    positionX: Long,
    positionY: Long,
    pieceType: TetrominoType,
  ): Long {
    val result = driver.execute(-283_525_135, """
        |INSERT OR REPLACE INTO BoardCells (positionX, positionY, pieceType)
        |VALUES (?, ?, ?)
        """.trimMargin(), 3) {
          var parameterIndex = 0
          bindLong(parameterIndex++, positionX)
          bindLong(parameterIndex++, positionY)
          bindString(parameterIndex++, BoardCellsAdapter.pieceTypeAdapter.encode(pieceType))
        }.await()
    notifyQueries(-283_525_135) { emit ->
      emit("BoardCells")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun clearAllCells(): Long {
    val result = driver.execute(-1_709_401_177, """DELETE FROM BoardCells""", 0).await()
    notifyQueries(-1_709_401_177) { emit ->
      emit("BoardCells")
    }
    return result
  }
}
